<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-10 16:42:46
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-10 16:42:54
 * @FilePath: /chaoyongtuan/src/views/talentCRM/tagManagement/components/tableCell/talentCount.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <el-link type="primary" @click="skipUrl(row)">{{ row.tag_use_count }}</el-link>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
    methods:{
        skipUrl({ id, tag_name }) {
			let handLink = this.$router.resolve({
				path: '/talentCRM/groupSeas',
				query: {
					tag_id: id,
					tag_name,
				},
			});
			window.open(handLink.href, '_blank');
		},
    }
};
</script>